<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <h2>Edit Dates</h2>
        <fa-icon class="close" (click)="closeDialog()" [icon]="['fas', 'times']"></fa-icon>
    </div>
</div>

<form [formGroup]="formGroup">
    <div fxLayout="row" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
        <!-- Start Date -->
        <mat-form-field appearance="outline" fxFlex>
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startDatePicker" formControlName="StartDate"
                [disabled]="formGroup.disabled">
            <mat-error *ngIf="startDate?.hasError('required')">
                Start date is required.
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"
                [disabled]="formGroup.disabled"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker [disabled]="formGroup.disabled"></mat-datepicker>
        </mat-form-field>

        <!-- End Date -->
        <mat-form-field appearance="outline" fxFlex>
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endDatePicker" formControlName="EndDate" [disabled]="formGroup.disabled">
            <mat-error *ngIf="endDate?.hasError('required')">
                End date is required.
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"
                [disabled]="formGroup.disabled"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker [disabled]="formGroup.disabled"></mat-datepicker>
        </mat-form-field>
    </div>

    <!-- Group-level date range error -->
    <div *ngIf="formGroup.hasError('dateRangeInvalid') && (formGroup.touched || formGroup.dirty)" class="mat-error"
        style="margin-top: 8px;">
        End Date must be equal to or greater than Start Date
    </div>

    <mat-card-actions fxLayout="row" fxLayoutAlign="end" style="margin-top: 16px;">
        <button mat-stroked-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="accent" type="button" (click)="updateDates()"
            [disabled]="formGroup.invalid || formGroup.disabled">Save</button>
    </mat-card-actions>
</form>